<template>
  <div class="tab-tool">
    <div class="tab-title dt-fz22"><i></i>{{ toolListProps.toolTitle }}</div>
    <!-- 插槽 -->
    <slot name="tips"></slot>
    <div class="tab-wrap" v-for="(item, index) in toolList" :key="index">
      <el-button v-if="!isInclude(item.name)" type="text" :icon="item.icon" @click="handleTool(item)">
        <span v-if="!isIncludeDownload(item.name)">{{ item.name }}</span>
        <span v-else>
          <a
            :href="item.downloadURL"
            :download="item.downloadURL"
            class="download-btn"
            :style="{ color: themeObj.color }"
            >{{ item.name }}</a
          >
        </span>
      </el-button>
      <el-button type="text" v-else :icon="item.icon" @click="fileClick(item, index)">{{ item.name }}</el-button>
      <input
        type="file"
        :id="'file' + index"
        style="display: none"
        multiple="true"
        ref="file"
        name="termFile"
        @change="fileChange($event, item, index)"
      />
    </div>
    <slot name="rightContent"></slot>
  </div>
</template>

<script>
import { hasRights } from '@/config/tool';
import fileImport from '@/utils/fileImport';
import { rootPath } from '@/utils/globalParam';
import http from '@/utils/httpService';
export default {
  name: '',
  props: {
    toolListProps: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mapToolIcon: {
        新增: { icon: 'iconfont icondt8' },
        新增租户: { icon: 'iconfont icondt8' },
        新增用户: { icon: 'iconfont icondt8' },
        新增角色: { icon: 'iconfont icondt8' },
        添加应用: { icon: 'iconfont icondt8' },
        新增主菜单: { icon: 'iconfont icondt8' },
        新增子菜单: { icon: 'iconfont icondt8' },
        新增一级机构: { icon: 'iconfont icondt8' },
        新增子机构: { icon: 'iconfont icondt8' },
        新增字典项: { icon: 'iconfont icondt8' },
        新增参数: { icon: 'iconfont icondt8' },
        新增一级部门: { icon: 'iconfont icondt8' },
        新增子部门: { icon: 'iconfont icondt8' },
        导出: { icon: 'iconfont icondt10' },
        导出机构: { icon: 'iconfont icondt10' },
        导出部门: { icon: 'iconfont icondt10' },
        下载模板: { icon: 'iconfont icondt10' },
        导入: { icon: 'iconfont icondt21' },
        导入机构: { icon: 'iconfont icondt21' },
        导入部门: { icon: 'iconfont icondt21' },
        清空: { icon: 'iconfont icondt24' },
        删除已选字典: { icon: 'iconfont icondt24' },
        删除参数: { icon: 'iconfont icondt24' },
        关联租户: { icon: 'iconfont icondt20' },
        新增字典: { icon: 'iconfont icondt8' },
        删除已选类型: { icon: 'iconfont icondt24' },
        充值: { icon: 'iconfont icondt8' },
        分配: { icon: 'iconfont icondt9' },
        分配明细: { icon: 'iconfont icondt3' },
        回收明细: { icon: 'iconfont icondt3' },
      },
    };
  },
  computed: {
    toolList() {
      let toolListProps = this._.cloneDeep(this.toolListProps);
      this._.each(this.mapToolIcon, (val, key) => {
        let item = this._.find(toolListProps.toolList, el => {
          return el.name == key;
        });
        if (item) {
          item.icon = val.icon;
          // item.btnCode = val.btnCode || "";
        }
      });
      toolListProps.toolList = this._.filter(toolListProps.toolList, item => {
        return hasRights(item.btnCode);
      });
      return toolListProps.toolList;
    },
    themeObj() {
      return this.$store.getters['layoutStore/getThemeObj'];
    },
  },
  watch: {},
  created() {},
  methods: {
    fileClick(item, index) {
      document.getElementById('file' + index).click();
    },
    fileChange(e, item, index) {
      let files = this.$refs.file[index].files[0];
      if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message({
          type: 'error',
          message: '上传格式不正确，请上传xls或者xlsx格式',
        });
        return false;
      }
      http.Axios.post(item.action, files, { isImport: true, noError: true }).then(res => {
        if (res.resp_code == 1) {
          this.$message({
            showClose: true,
            message: res.resp_msg,
            type: 'error',
          });
          e.target.value = '';
          return;
        }
        e.target.value = '';

        this.$emit('fileUpload', true);
      });
    },
    isInclude(item) {
      let arr = ['导入', '导入机构', '导入部门'];
      return this._.includes(arr, item);
    },
    isIncludeDownload(item) {
      let arr = ['下载模板'];
      return this._.includes(arr, item);
    },
    handleTool(item) {
      this.$emit('handleTool', item);
    },
  },
};
</script>

<style lang="less">
.tab-tool {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  background-color: #fff; // padding-left: 10px;
  .tab-title {
    display: flex;
    align-items: center;
    margin-right: 10px;
    font-size: 18px;
    font-weight: 400;
    color: #555;
    i {
      width: 4px;
      height: 16px;
      margin-right: 6px;
      background-color: #e27c00;
    }
  }
  .tab-wrap {
    display: inline-block;
    margin-right: 15px;
    .el-button--medium {
      padding-top: 12px;
      padding-bottom: 18px;
    }
  }
  .iconfont {
    position: relative;
    top: 2px;
    font-size: 22px;
  }
  a {
    text-decoration: none;
  }
}
</style>
